const UNSAFE_ID_CHARS = /[^A-Za-z0-9_-]/g;

/** DOM id of a row's sub-component row; use it for the toggle's `aria-controls`. */
export const getTableRowDetailId = (
  tableTestId: string | undefined,
  rowId: string | number
): string =>
  `${tableTestId || "table"}-row-detail-${String(rowId).replace(UNSAFE_ID_CHARS, "_")}`;
